import {RealtimeEventType, TrustStatus} from '@sollapay/enums';
import {useQueryClient} from '@tanstack/react-query';
import {useNavigate} from 'react-router-dom';

import {useRealtimeEvent} from '@/hooks/useRealtimeEvent';

import {showTrustAccountActivatedToast} from '../components';
import {trustAccountKeys} from './useTrustAccounts';

export function useTrustAccountRealtimeUpdates(): void {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  useRealtimeEvent(RealtimeEventType.TrustAccountStatusChanged, event => {
    void queryClient.invalidateQueries({queryKey: trustAccountKeys.lists()});
    void queryClient.invalidateQueries({queryKey: trustAccountKeys.detail(event.trustAccountId)});

    if (event.trustStatus === TrustStatus.TRUST_ACTIVE) {
      void queryClient.invalidateQueries({queryKey: trustAccountKeys.balances()});
      void queryClient.invalidateQueries({
        queryKey: trustAccountKeys.balance(event.trustAccountId)
      });
      showTrustAccountActivatedToast(event.trustAccountId, () =>
        navigate(`/trust-accounts/${event.trustAccountId}`)
      );
    }
  });
}
